// Converted to lazy loading
const manufacturingModelsIndex = () => import('@/pages/manufacturing/manufacturingModels/index.vue')
const manufacturingModelsForm = () => import('@/pages/manufacturing/manufacturingModels/form.vue')
const manufacturingModelsShow = () => import('@/pages/manufacturing/manufacturingModels/show.vue')

const manufacturingOperationsIndex = () =>
  import('@/pages/manufacturing/manufacturingOperations/index.vue')
const manufacturingOperationsForm = () =>
  import('@/pages/manufacturing/manufacturingOperations/form.vue')
const manufacturingOperationsShow = () =>
  import('@/pages/manufacturing/manufacturingOperations/show.vue')
const productManufacturingModelsForm = () =>
  import('@/pages/manufacturing/productsManufacturingModels/form.vue')
const manufacturingTestIndex = () => import('@/pages/manufacturing/manufacturingTest/index.vue')
const routes = [
  //manufacturingModels routes

  {
    path: 'manufacturingModels',
    name: 'manufacturingModels',
    component: manufacturingModelsIndex
  },
  {
    path: 'manufacturingModels/create',
    name: 'manufacturingModelsCreate',
    component: manufacturingModelsForm
  },

  {
    path: 'manufacturingModels/:id/edit',
    name: 'manufacturingModelsEdit',
    component: manufacturingModelsForm
  },

  {
    path: 'manufacturingModels/:id',
    name: 'manufacturingModelsShow',
    component: manufacturingModelsShow
  },

  //manufacturingOperations routes
  {
    path: 'manufacturingOperations',
    name: 'manufacturingOperations',
    component: manufacturingOperationsIndex
  },
  {
    path: 'manufacturingOperations/create',
    name: 'manufacturingOperationsCreate',
    component: manufacturingOperationsForm
  },
  {
    path: 'manufacturingOperations/:id/edit',
    name: 'manufacturingOperationsEdit',
    component: manufacturingOperationsForm
  },
  {
    path: 'manufacturingOperations/:id',
    name: 'manufacturingOperationsShow',
    component: manufacturingOperationsShow
  },
  {
    path: 'productsManufacturingModels/',
    name: 'productsManufacturingModels',
    component: productManufacturingModelsForm
  },
  {
    path: 'manufacturingTest',
    name: 'manufacturingTest',
    component: manufacturingTestIndex
  }
  //manufacturingDeposits routes
]

export default routes
